export default __webpack_public_path__ + "static/media/play-intro-btn.37f566bc.svg";